import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  SettingsBody,
  SettingsData,
  SettingsHeadBar,
  SettingsHeadTitle,
} from '~/components/settings';
import { StripedCard } from '~/components/striped-card';
import { DeviceNetworkingProvider } from '~/generated/graphql';
import ExtremeNetworksLogo from '~/images/extreme-networks-logo.png';
import type { Device } from '../types';

interface NetworkingPanelProps {
  networking: NonNullable<Device['networking']>;
}

export const NetworkingPanel = ({ networking }: NetworkingPanelProps) => {
  const { t } = useTranslation();

  return (
    <Grid item>
      <SettingsHeadBar sx={{ justifyContent: 'space-between' }}>
        <SettingsHeadTitle>{t('pages.devices.show.networking.title')}</SettingsHeadTitle>
        {networking.switch?.provider === DeviceNetworkingProvider.Extreme && (
          <Box
            component="img"
            src={ExtremeNetworksLogo}
            alt={t('pages.devices.show.networking.logo_alt')}
            sx={{ height: 28, width: 'auto', opacity: 0.75 }}
          />
        )}
      </SettingsHeadBar>
      <SettingsBody>
        <SettingsData className="last">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <StripedCard content={networking.ipAddress} label={t('common.labels.ip_address')} />
            </Grid>
            <Grid item xs={12} md={4}>
              <StripedCard
                content={networking.macAddress}
                label={t('pages.devices.show.details.mac_address')}
              />
            </Grid>
            {networking.switch?.name && (
              <Grid item xs={12} md={4}>
                <StripedCard
                  content={networking.switch.name}
                  label={t('pages.devices.show.networking.switch_name')}
                />
              </Grid>
            )}
            {networking.switch?.model && (
              <Grid item xs={12} md={4}>
                <StripedCard
                  content={networking.switch.model}
                  label={t('pages.devices.show.networking.switch_model')}
                />
              </Grid>
            )}
            {networking.switch?.port.id && (
              <Grid item xs={12} md={4}>
                <StripedCard
                  content={networking.switch.port.id}
                  label={t('pages.devices.show.networking.port_id')}
                />
              </Grid>
            )}
            {networking.switch?.port.speed && (
              <Grid item xs={12} md={4}>
                <StripedCard
                  content={networking.switch.port.speed}
                  label={t('pages.devices.show.networking.speed')}
                />
              </Grid>
            )}
          </Grid>
        </SettingsData>
      </SettingsBody>
    </Grid>
  );
};
